/* assets/bundle-progress.js */
/* Prestige-safe (no inline JS). Includes debug logging if data-debug="true". */

(function(){
  function init(root){
    if (!root || root.__bpInit) return;
    root.__bpInit = true;

    const DEBUG = String(root.getAttribute('data-debug')).toLowerCase() === 'true';
    function log(){ if (DEBUG) console.log('[bundle-progress]', ...arguments); }

    function parseJSONAttr(el, attr, fallback){
      try{ const raw = el.getAttribute(attr); return raw ? JSON.parse(raw) : fallback; }
      catch(e){ return fallback; }
    }

    const moneyFormat      = parseJSONAttr(root, 'data-money-format', "${{amount}}");
    const productId        = String(root.getAttribute('data-product-id') || '');
    const defaultVariantId = root.getAttribute('data-default-variant-id');
    const defaultPrice     = Number(root.getAttribute('data-default-price')) || 0;
    const discounts        = parseJSONAttr(root, 'data-discounts', [0,0,10,15,20]);

    const scope    = root.getAttribute('data-scope') || 'product';
    const scopeIds = parseJSONAttr(root, 'data-scope-ids', []).map(String);
    const currentProductId = productId;

    if (DEBUG){
      const badge = document.createElement('div');
      badge.textContent = 'JS loaded ✓';
      badge.style.cssText = 'position:absolute;top:-10px;left:8px;background:#e6ffed;color:#03543f;padding:3px 6px;border-radius:6px;font-size:11px;font-weight:700;border:1px solid #84e1bc';
      root.appendChild(badge);
      log('init', {scope, scopeIdsCount: scopeIds.length, productId, defaultVariantId, defaultPrice, discounts});
    }

    function formatMoney(cents){
      try{ if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, moneyFormat); }catch(e){}
      return (cents/100).toFixed(2);
    }

    function getSelectedVariantId(){
      const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (idInput && idInput.value) return idInput.value;
      const sel = document.querySelector('select[name="id"]');
      if (sel && sel.value) return sel.value;
      const urlVar = new URL(window.location.href).searchParams.get('variant');
      if (urlVar) return urlVar;
      return defaultVariantId;
    }

    function priceForVariant(vid){
      try{
        const txt = root.querySelector('.bb-variant-data')?.textContent || '[]';
        const arr = JSON.parse(txt);
        const hit = arr.find(v => String(v.id) === String(vid));
        if (hit && typeof hit.price === 'number' && hit.price > 0) return hit.price;
      }catch(e){}
      return defaultPrice;
    }

    function computeTierCents(baseCents){
      return discounts.map(p => Math.round(baseCents * (100 - Number(p||0)) / 100));
    }

    // Prices
    function paintPrices(){
      const base = priceForVariant(getSelectedVariantId());
      const nodes = root.querySelectorAll('.js-money');
      if (DEBUG) log('paintPrices base', base);
      if (base > 0){
        const centsArr = computeTierCents(base);
        centsArr.forEach((c,i)=>{ const n=nodes[i]; if(!n) return; n.setAttribute('data-money', String(c)); n.textContent = formatMoney(c); });
      } else {
        nodes.forEach(n=>{ const c = Number(n.getAttribute('data-money'))||0; n.textContent = formatMoney(c); });
      }
    }

    // Progress
    const bar    = root.querySelector('.bb-bar');
    const stops  = Array.from(root.querySelectorAll('.bb-stop'));
    const labels = Array.from(root.querySelectorAll('.bb-labels .bb-col'));
    const prices = Array.from(root.querySelectorAll('.bb-prices .bb-col'));
    const TIERS  = 5;

    function setProgress(qty){
      qty = Number(qty) || 0; if (qty<0) qty=0; if (qty>TIERS) qty=TIERS;
      const gaps = TIERS - 1;
      let widthPct = 0;
      if (qty === 1) widthPct = 2;
      else if (qty > 1) widthPct = ((qty - 1) / gaps) * 100;
      if (bar) bar.style.width = widthPct + '%';

      stops.forEach((s,i)=> s.classList.toggle('active', i < qty));
      const idx = Math.max(1, qty) - 1;
      labels.forEach((c,i)=> c.classList.toggle('active', i===idx));
      prices.forEach((c,i)=> c.classList.toggle('active', i===idx));

      if (DEBUG) log('setProgress qty', qty, 'widthPct', widthPct);
    }

    async function getCart(){
      const r = await fetch('/cart.js?ts=' + Date.now(), {headers:{'Accept':'application/json'}});
      if (!r.ok) throw new Error('cart');
      return r.json();
    }

    function qtyForScope(cart){
      let q = 0;
      (cart.items || []).forEach(it => {
        const pid = String(it.product_id);
        if (scope === 'collection' && scopeIds.length) {
          if (scopeIds.includes(pid)) q += it.quantity;
        } else {
          if (pid === currentProductId) q += it.quantity;
        }
      });
      if (DEBUG) log('qtyForScope', q, cart.items);
      return q;
    }

    async function refreshProgress(){
      try { const cart = await getCart(); setProgress(qtyForScope(cart)); } catch(e){ if (DEBUG) log('cart fetch error', e); }
    }

    // Init + events
    paintPrices(); refreshProgress();

    document.addEventListener('shopify:currency:change', paintPrices, true);
    ['variant:changed','product:variant-change','theme:variant:change'].forEach(ev=>{
      document.addEventListener(ev, ()=> setTimeout(paintPrices,0), true);
    });
    ['change','input'].forEach(ev=>{
      document.addEventListener(ev, e=>{
        const t=e.target;
        if (t && (t.name==='id' || t.closest('form[action*="/cart/add"]'))) setTimeout(paintPrices,0);
      }, true);
    });

    ['cart:refresh','theme:cart:updated','ajaxProduct:added','product:added','added.to.cart','cart:updated']
      .forEach(ev => document.addEventListener(ev, burstRefresh, true));

    document.querySelectorAll('form[action*="/cart/add"]').forEach(f=>{
      f.addEventListener('submit', ()=> setTimeout(burstRefresh, 200), true);
    });

    const _fetch = window.fetch;
    window.fetch = async function(){
      const res = await _fetch.apply(this, arguments);
      try{ const url = (arguments[0] && arguments[0].toString()) || '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) setTimeout(burstRefresh,120);
      }catch(e){}
      return res;
    };

    (function(){
      const XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function(m,u){ this._bp_isCart=/\/cart\/(add|change|update|clear)\.?(js|json)?/.test(u); return XO.apply(this, arguments); };
      XMLHttpRequest.prototype.send = function(){ if (this._bp_isCart) this.addEventListener('load', ()=> setTimeout(burstRefresh,120)); return XS.apply(this, arguments); };
    })();

    function burstRefresh(){
      refreshProgress();
      let n=0; const id=setInterval(()=>{ n++; refreshProgress(); if(n>=6) clearInterval(id); }, 300);
    }
  }

  function initAll(){ document.querySelectorAll('.bb-card[data-product-id]').forEach(init); }
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
